var _sodipodiNamedview, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "130mm",
    height: "50mm",
    viewBox: "0 0 130 50",
    id: "svg1",
    inkscapeVersion: "1.3.2 (091e20e, 2023-11-25)",
    sodipodiDocname: "website-logo.svg",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview1",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1",
    "inkscapeDocument-units": "mm",
    inkscapeZoom: 0.97850546,
    inkscapeCx: 165.04762,
    inkscapeCy: 117.01519,
    "inkscapeWindow-width": 1408,
    "inkscapeWindow-height": 666,
    "inkscapeWindow-x": 150,
    "inkscapeWindow-y": 189,
    "inkscapeWindow-maximized": 0,
    "inkscapeCurrent-layer": "layer1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Layer 1",
    inkscapeGroupmode: "layer",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 21.433771,46.038806 9.757208,-19.911947 -22.277566,8.151336 9.771531,2.742079 z",
    style: {
      fill: "#21b602",
      fillOpacity: 1,
      strokeWidth: 0.130467
    },
    id: "path2-8-18-39-8",
    sodipodiNodetypes: "ccccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#21b602",
      fillOpacity: 1,
      strokeWidth: 0.145104
    },
    id: "path3-1-9-8-2",
    transform: "matrix(-0.33442138,-0.94242365,0.95899964,-0.28340729,0,0)",
    cy: 0.27524313,
    cx: -42.854111,
    rx: 2.1139762,
    ry: 2.2764361
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.459786,46.424844 -8.933994,-19.645982 -9.422547,19.454969 9.230478,-4.08286 z",
    style: {
      fill: "#ff7f24",
      fillOpacity: 1,
      strokeWidth: 0.130467
    },
    id: "path2-8-8-6-9",
    sodipodiNodetypes: "ccccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#ff7f24",
      fillOpacity: 1,
      strokeWidth: 0.145175
    },
    id: "path3-1-04-57-8",
    transform: "matrix(-0.92164652,-0.38803054,0.45116559,-0.89244025,0,0)",
    cy: -30.23913,
    cx: -49.82869,
    rx: 2.2608013,
    ry: 2.1306887
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.5025783,16.533032 30.620812,24.800352 8.3334442,32.929324 13.332357,24.791363 Z",
    style: {
      fill: "#0089db",
      fillOpacity: 1,
      strokeWidth: 0.130467
    },
    id: "path2-8-18-3-6-2",
    sodipodiNodetypes: "ccccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#0089db",
      fillOpacity: 1,
      strokeWidth: 0.145184
    },
    id: "path3-1-9-6-2-0",
    transform: "matrix(0.46631035,0.88462119,0.91565297,-0.4019697,0,0)",
    cy: -4.6875687,
    cx: 26.115862,
    rx: 2.1332552,
    ry: 2.2583795
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22.441945,3.5889157 31.180444,23.308005 9.5088425,15.47849 19.225047,12.477575 Z",
    style: {
      fill: "#bb3385",
      fillOpacity: 1,
      strokeWidth: 0.130467
    },
    id: "path2-8-8-5-7-7",
    sodipodiNodetypes: "ccccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#bb3385",
      fillOpacity: 1,
      strokeWidth: 0.145132
    },
    id: "path3-1-04-5-0-4",
    transform: "matrix(-0.38216303,0.92409492,0.94549435,0.32563849,0,0)",
    cy: 18.447678,
    cx: 3.8220558,
    rx: 2.1201644,
    ry: 2.270674
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 24.099783,3.3208769 32.685575,23.095754 42.450571,3.7819343 33.14917,7.7284708 Z",
    style: {
      fill: "#ffb124",
      fillOpacity: 1,
      strokeWidth: 0.130467
    },
    id: "path2-8-8-5-7-3-8",
    sodipodiNodetypes: "ccccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#ffb124",
      fillOpacity: 1,
      strokeWidth: 0.145184
    },
    id: "path3-1-04-5-0-8-5",
    transform: "matrix(0.91565293,0.40196978,-0.46631043,0.88462115,0,0)",
    cy: -10.142385,
    cx: 31.175179,
    rx: 2.2583795,
    ry: 2.1332555
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "15.5279px",
      fontFamily: "HarmoniaSansW06-BlackIt",
      InkscapeFontSpecification: "'HarmoniaSansW06-BlackIt Bold'",
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.207963
    },
    x: 39.574631,
    y: 26.433067,
    id: "text5-8",
    transform: "scale(1.0572537,0.94584678)"
  }, /*#__PURE__*/React.createElement("tspan", {
    sodipodiRole: "line",
    id: "tspan5-7",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "15.5279px",
      fontFamily: "HarmoniaSansW01-Bold",
      InkscapeFontSpecification: "'HarmoniaSansW01-Bold Bold'",
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.207963
    },
    x: 39.574631,
    y: 26.433067
  }, "Safer West")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "9.98222px",
      fontFamily: "HarmoniaSansW06-BlackIt",
      InkscapeFontSpecification: "'HarmoniaSansW06-BlackIt Bold'",
      fill: "#344050",
      fillOpacity: 0.593625,
      strokeWidth: 0.207963
    },
    x: 39.944695,
    y: 36.389015,
    id: "text6-7",
    transform: "scale(1.0572537,0.94584678)"
  }, /*#__PURE__*/React.createElement("tspan", {
    sodipodiRole: "line",
    id: "tspan6-4",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "9.98222px",
      fontFamily: "HarmoniaSansW01-Bold",
      InkscapeFontSpecification: "'HarmoniaSansW01-Bold Bold'",
      fill: "#344050",
      fillOpacity: 0.593625,
      strokeWidth: 0.207963
    },
    x: 39.944695,
    y: 36.389015
  }, "S\xE1bh\xE1ilte Thiar"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteLogo);
export default __webpack_public_path__ + "static/media/website-logo.59612158b6f44128380262d665299869.svg";
export { ForwardRef as ReactComponent };